/**
 * Conversion-focused behaviors for You Good? Clothing
 * Includes sticky ATC, exit intent, and scroll triggers
 */

class ConversionBehaviors {
  constructor() {
    this.init();
  }

  init() {
    this.setupStickyATC();
    this.setupScrollTriggers();
    this.setupViewTracking();

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.enhanceButtons();
      });
    } else {
      this.enhanceButtons();
    }
  }

  /**
   * Scroll-triggered animations
   */
  setupScrollTriggers() {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-slide-in-up');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe conversion elements
    document.querySelectorAll('.value-highlight, .conversion-guarantee, .impact-stat').forEach(el => {
      observer.observe(el);
    });
  }

  /**
   * Track product views for social proof
   */
  setupViewTracking() {
    if (!document.querySelector('.product')) return;

    const viewCount = document.querySelector('.urgency-indicator--social');
    if (viewCount) {
      // Simulate real-time updates (every 30-60 seconds)
      setInterval(() => {
        const currentText = viewCount.querySelector('.urgency-indicator__text');
        if (currentText) {
          const match = currentText.innerHTML.match(/\d+/);
          if (match) {
            const current = parseInt(match[0]);
            const change = Math.random() > 0.5 ? 1 : -1;
            const newCount = Math.max(3, Math.min(15, current + change));
            currentText.innerHTML = currentText.innerHTML.replace(/\d+/, `<strong>${newCount}</strong>`);
          }
        }
      }, 45000); // Every 45 seconds
    }
  }

  /**
   * Enhance buttons with hover effects
   */
  enhanceButtons() {
    document.querySelectorAll('.button--conversion').forEach(button => {
      if (button.dataset.enhanced) return;
      button.dataset.enhanced = 'true';

      // Add ripple effect on click
      button.addEventListener('click', function(e) {
        const ripple = document.createElement('span');
        ripple.classList.add('button-ripple');

        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;

        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';

        this.appendChild(ripple);

        setTimeout(() => ripple.remove(), 600);
      });
    });
  }
}

// Initialize when script loads
if (typeof window !== 'undefined') {
  new ConversionBehaviors();
}

// Add ripple styles
const style = document.createElement('style');
style.textContent = `
  .button {
    position: relative;
    overflow: hidden;
  }

  .button-ripple {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.3);
    transform: scale(0);
    animation: ripple-animation 0.6s ease-out;
    pointer-events: none;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(2);
      opacity: 0;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .button-ripple {
      animation: none;
    }
  }
`;

if (document.head) {
  document.head.appendChild(style);
} else {
  document.addEventListener('DOMContentLoaded', () => {
    document.head.appendChild(style);
  });
}
